import { render } from "./NewKnowledgeBase.vue?vue&type=template&id=1ae85d5d&scoped=true&lang=pug"
import script from "./NewKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./NewKnowledgeBase.vue?vue&type=script&lang=js"

import "./NewKnowledgeBase.vue?vue&type=style&index=0&id=1ae85d5d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae85d5d"]])

export default __exports__